var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nihao" }, [
    _c(
      "div",
      { staticClass: "msgSort" },
      [
        _c(
          "el-tabs",
          {
            attrs: { stretch: true, type: "card" },
            on: { "tab-click": _vm.tabClick },
            model: {
              value: _vm.msgSort,
              callback: function($$v) {
                _vm.msgSort = $$v
              },
              expression: "msgSort"
            }
          },
          [
            _c("el-tab-pane", {
              attrs: {
                label: "全部",
                name: "all",
                disabled: !_vm.searchData().idData || !_vm.isRequestSuccess
              }
            }),
            _c("el-tab-pane", {
              attrs: {
                label: "文件",
                name: "file",
                disabled: !_vm.searchData().idData || !_vm.isRequestSuccess
              }
            }),
            _c("el-tab-pane", {
              attrs: {
                label: "图片",
                name: "image",
                disabled: !_vm.searchData().idData || !_vm.isRequestSuccess
              }
            }),
            _c("el-tab-pane", {
              attrs: {
                label: "语音",
                name: "call",
                disabled: !_vm.searchData().idData || !_vm.isRequestSuccess
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "chat-common" }, [
      _c(
        "div",
        { staticClass: "chat-massage" },
        [
          _c("GroupChatContent", {
            ref: "GroupChatContentRef",
            on: { requestSuccess: _vm.requestSuccess }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }